module.exports = __webpack_public_path__ + "img/formscount.662f43b9.png";